import(/* webpackChunkName: "lotteryTicketActivation" */ '../../Styles/lotteryTicketActivation.scss');

await import(/* webpackChunkName: "jquery-match-height" */ 'jquery-match-height');
await import(/* webpackChunkName: "forEach" */ 'Feature/Common/code/Scripts/Common/forEach');
await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');
await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');
await import(/* webpackChunkName: "postalcodeCountryValidator" */ 'Feature/Forms/code/Scripts/postalcodeCountryValidator');
await import(/* webpackChunkName: "lotteryTicketFormat" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketFormat');
await import(/* webpackChunkName: "lotteryTicketStartNumbers" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketStartNumbers');
await import(/* webpackChunkName: "explanationSlider" */ 'Feature/LotteryContentElements/code/Scripts/LotteryTicket/explanationSlider');
await import(/* webpackChunkName: "tools" */ 'Common/Scripts/Common/tools');
await import(/* webpackChunkName: "ticket" */ 'Common/Scripts/Ticket/ticket');
await import(/* webpackChunkName: "input-mask" */ 'Foundation/Forms/code/Scripts/input-mask');
await import(/* webpackChunkName: "iban" */ 'Foundation/Forms/code/Scripts/iban');
await import(/* webpackChunkName: "base64" */ 'Foundation/Common/code/Scripts/Common/base64');
await import(/* webpackChunkName: "groupFormat" */ 'Common/Scripts/Common/groupFormat');
await import(/* webpackChunkName: "dateformat" */ 'Foundation/Forms/code/Scripts/dateformat');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');
await import(/* webpackChunkName: "requiredWhen" */ 'Foundation/Forms/code/Scripts/requiredWhen');
await import(/* webpackChunkName: "requiredLegalAge" */ 'Foundation/Forms/code/Scripts/requiredLegalAge');
await import(/* webpackChunkName: "disallowCharacter" */ 'Foundation/Forms/code/Scripts/disallowCharacter');

await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');

await import(/* webpackChunkName: "postalcodeCountryFormValidationInitializer" */ 'Feature/Forms/code/Scripts/postalcodeCountryFormValidationInitializer');

window.am = window.am || {};

window.am.lotteryTicketActivation = new function () {

    var that = this;


    //find iban input field and set an input event listener 
    let ibanFieldInputFields = document.querySelectorAll('input#Iban');
    if (ibanFieldInputFields) {

        for (var i = 0; i < ibanFieldInputFields.length; i++) {
            let ibanFieldInputField = ibanFieldInputFields[i];
            ibanFieldInputField.addEventListener('input', function (element) {
                //if there was a backend iban error, remove general error and field error on filling in the iban field
                var ibanFieldElement = this.parent('.form-field.iban-various-validation.validation-service-error');
                if (ibanFieldElement) {
                    submitValidationFailedFunc(ibanFieldElement, this);
                }
            });
        }
    }

    
    that.init = function () {
        initShowHideIban();
        initAccordionRichtext();
    }

    function initAccordionRichtext() {
        var textsWithAdditionalText = document.querySelectorAll('.richtext.with-additional-text a[data-additional-text]');

        for (var j = 0; j < textsWithAdditionalText.length; j++) {
            var textWithAdditionalText = textsWithAdditionalText[j];

            textWithAdditionalText.addEventListener('click', function (e) {
                e.preventDefault();
                that.toggleAdditionalText(this);
            });
        }
    }


    function initShowHideIban() {
        var lotteryActivationForms = document.querySelectorAll('.lotteryticket-activation');

        if (lotteryActivationForms == null) {
            return;
        }

        for (var i = 0; i < lotteryActivationForms.length; i++) {
            var lotteryActivationForm = lotteryActivationForms[i];

            window.am.forms.initShowHideIbanByParent(lotteryActivationForm, 'ProfitPayout', changedCallback);
        }
    }

    function changedCallback(element, targetElement) {
        if (element.value == 'false') {
            // get correct txt field
            var ibanField = targetElement.querySelector(
                'input[type="text"]:not(:disabled)');

            if (ibanField) {
                ibanField.value = '';
                /* values changes via js doesnt trigger input change event */
                triggerChangeEvent(ibanField, 'input');

                var $iban = $(ibanField);

                $iban.valid();
            }
        }
    }

    function triggerChangeEvent(element, eventName) {
        var event;

        /* With IE support */
        if (typeof (Event) === 'function') {
            event = new Event(eventName);
        }
        else {
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }

        element.dispatchEvent(event);
    }

    ///**
    // * Gets called if the generic validation is failed. Resets the error container and element class.
    // * Replaces the service error field error message with the original error message
    // * @param {any} ibanFieldItem
    // * @param {any} element (iban input element)
    // */
    function submitValidationFailedFunc(ibanFieldItem, element) {

        let form = ibanFieldItem.parent('.am-form');

        if (form == null) {
            return false;
        }

        var withValidationServiceErrorFields = form.querySelectorAll(".validation-service-error");

        if (withValidationServiceErrorFields && withValidationServiceErrorFields.length == 1) {
            //Do error container magic
            let notificationContainer = form.querySelector('.global-notification-container.notification-container');

            if (notificationContainer == null) {
                return false;
            }

            if (notificationContainer.classList.contains('active')) {
                let errorMessageLinkElement = notificationContainer.querySelector('a[href="#Iban"]');
                if (errorMessageLinkElement) {
                    let errorMessageListElement = errorMessageLinkElement.parent('li');
                    if (errorMessageListElement) {
                        let ulElement = errorMessageListElement.parent('ul')
                        if (ulElement) {
                            ulElement.removeChild(errorMessageListElement);
                            let otherErrorMessageListElements = ulElement.querySelectorAll('li');
                            if (!otherErrorMessageListElements || (otherErrorMessageListElements && otherErrorMessageListElements.length == 0)) {
                                notificationContainer.classList.remove('active');
                                notificationContainer.classList.add('no-errors');
                            }
                        }                        
                    }
                }                
            }
        }

        ibanFieldItem.classList.remove(that.inputErrorClass);
        ibanFieldItem.classList.add('no-errors');
        ibanFieldItem.classList.remove('validation-service-error');
        let fieldNotificationContainer = ibanFieldItem.querySelector('.error.notification-container');
        fieldNotificationContainer.querySelector('div.message').querySelector('p').innerHTML = element.getAttribute('data-alt-validation-message');
    }

    that.toggleAdditionalText = function (element) {
        var richtextParent = element.parent('.with-additional-text');

        if (!richtextParent) {
            return;
        }

        var additionalText = richtextParent.querySelector('.additional-text');

        if (additionalText != null && additionalText != undefined) {
            if (additionalText.classList.contains('show')) {
                additionalText.classList.remove('show');
                $(additionalText).stop().slideUp();
            }
            else {
                additionalText.classList.add('show');
                $(additionalText).stop().slideDown();
            }
        }
    }
}

window.am.lotteryTicketActivation.init();